var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommonIndex',{attrs:{"pageType":_vm.pageType,"show-threshold":true,"showThreshold":false},on:{"showDetail":_vm.showDetail},scopedSlots:_vm._u([{key:"expandButton",fn:function({ record }){return _c('span',{staticStyle:{"margin-right":"15px"},on:{"click":function($event){return _vm.monitoringPoint(record)}}},[_vm._v(" 监测点 ")])}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }